/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { MtmaModule, MtmaSettingsModules } from 'src/app/model/mtma-module';
import { Observable, Subscription } from 'rxjs';
import { selecMtmaSettingsModules, selectMtmaActiveTask, selectMtmaEditModule } from 'src/app/store/device/device.selector';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MtmaTask } from 'src/app/model/mtma-task';
import { StandardNewValidator, StandardPageLayout, StandardDynamicComponent } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-mtma-manage-module-bfvs',
	templateUrl: './mtma-manage-module-bfvs.component.html',
	animations: [],
})

export class MtmaManageModuleBfvsComponent implements OnInit, OnDestroy {
	mtmaSettingsModules$: Observable<MtmaSettingsModules[] | undefined>;
	mtmaSettingsModulesSub: Subscription | undefined;
	mtmaActiveTask$: Observable < MtmaTask | undefined >;
	mtmaActiveTaskSub: Subscription | undefined;
	editModule$: Observable<boolean | undefined>;
	editModuleSub: Subscription | undefined;

	module: MtmaModule;
	moduleForm: FormGroup;

	isActiveTask = false;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private formBuilder: FormBuilder,
		public config: DynamicDialogConfig,
		private dialogRef: DynamicDialogRef,
	) { 
		if (this.config.data !== undefined && this.config.data.module !== undefined) {
			this.module = this.config.data.module;
		}
		this.initSelectors();
	}

	initSelectors(): void{
		this.mtmaSettingsModules$ = this.store.select(selecMtmaSettingsModules);
		this.mtmaActiveTask$ = this.store.select(selectMtmaActiveTask);
		this.editModule$ = this.store.select(selectMtmaEditModule);
	}

	ngOnInit(): void {
		this.moduleForm = this.formBuilder.group({
			Name: [this.module.Name, [Validators.required, Validators.maxLength(48)]],
		});
		this.mtmaActiveTaskSub = this.store.select('device', 'mtmaActiveTask').subscribe(mtmaActiveTask => {
			if (mtmaActiveTask.Id!==''){
				this.isActiveTask = true;
			} else {
				this.isActiveTask = false;
			}
		});
		this.editModuleSub = this.editModule$.subscribe(editModule => {
			if (editModule){
				this.closeDialog();
			} 
		});
		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	ngOnDestroy(): void {
		this.mtmaActiveTaskSub?.unsubscribe();
		this.editModuleSub?.unsubscribe();
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.moduleForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.moduleForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		this.module = {
			...this.module,
			Name: this.f.Name.value,
		};
		this.store.dispatch(DeviceActions.editMtmaModule({ module: this.module }));
	}

	closeDialog(): void {
	   this.dialogRef.close();
	}

	get f(): any {
		return this.moduleForm.controls;
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	underTablet(): boolean {
		return StandardPageLayout.underTablet(this.screenWidth);
	}

	col12Responsive() : string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicButtonWidth() : string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth() : string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth,'w-20rem');
	}

	dynamicInputTextDesktopTabletWidth() : string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-30rem', 'w-20rem');
	}

	justifyMessagesNewValidator() : string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: MtmaManageModuleBfvsComponent["f"], classType: string) : string {
		return StandardNewValidator.newShowErrors(type,classType,this.screenWidth);
	}

	dynamicAutocomplete() : string {
		return StandardDynamicComponent.dynamicAutocomplete(this.screenWidth);
	}

	dynamicBorderLabelMobile(classType: string) : string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: MtmaManageModuleBfvsComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	justifyContentStyle() : string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}
}
